import { EstablishmentFieldRequestDetail } from "@/services/establishment-field-request.service";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

interface Props {
  detail: EstablishmentFieldRequestDetail;
}

export const EstablishmentFieldRequestRejectMotive = ({ detail }: Props) => (
  <Flex flexDir="column" gap="8px">
    <Text fontWeight={700}>Motivo de rechazo</Text>
    <Flex flexDir="column" paddingX="24px" borderLeft={`4px solid ${AppColors.WHITE_BORDER_1}`}>
      <Text fontWeight={400}>{detail.motivoRechazo}</Text>
      <Text fontWeight={400} fontSize="12px" color={AppColors.GRAY_TEXT}>
        {detail.fechaRechazo
          ? dayjs
              .utc(detail.fechaRechazo)
              .tz("America/Argentina/Buenos_Aires")
              .format("DD/MM/YYYY - HH:mm")
          : "-"}{" "}
        - {detail.usuarioRechaza ?? "-"}
      </Text>
    </Flex>
  </Flex>
);
